/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'virtual-service';
const componentName = 'vs-list-page';
const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const vsLabel = `${prefix}.vsLabel`;
export const btnLabelBasicSetup = `${prefix}.btnLabelBasicSetup`;
export const btnLabelAdvancedSetup = `${prefix}.btnLabelAdvancedSetup`;
export const columnTitleAppDomainName = `${prefix}.columnTitleAppDomainName`;
export const columnTitleServicePorts = `${prefix}.columnTitleServicePorts`;
export const columnTitlePools = `${prefix}.columnTitlePools`;
export const columnTitleVirtualHosting = `${prefix}.columnTitleVirtualHosting`;
export const columnTitleVrfContext = `${prefix}.columnTitleVrfContext`;
export const columnTitleTotalServiceEngines = `${prefix}.columnTitleTotalServiceEngines`;
export const requestPerSecColumnTitle = `${prefix}.requestPerSecColumnTitle`;
export const connectionsPerSecColumnTitle = `${prefix}.connectionsPerSecColumnTitle`;
export const virtualHostingReferenceColumnTitle = `${prefix}.virtualHostingReferenceColumnTitle`;
export const primaryLabel = `${prefix}.primaryLabel`;
export const parentLabel = `${prefix}.parentLabel`;
export const childLabel = `${prefix}.childLabel`;
export const enhancedVHLabel = `${prefix}.enhancedVHLabel`;
export const sniVHLabel = `${prefix}.sniVHLabel`;
export const columnValueSuffix = `${prefix}.columnValueSuffix`;
export const editToViewAllMessage = `${prefix}.editToViewAllMessage`;

export const ENGLISH = {
    [headerLabel]: 'Virtual Services',
    [vsLabel]: 'Virtual Services ({0})',
    [btnLabelBasicSetup]: 'Basic Setup',
    [btnLabelAdvancedSetup]: 'Advanced Setup',
    [columnTitleAppDomainName]: 'App Domain Name',
    [columnTitleServicePorts]: 'Service Ports',
    [columnTitlePools]: 'Pools',
    [columnTitleVirtualHosting]: 'Virtual Hosting',
    [columnTitleVrfContext]: 'VRF Context',
    [columnTitleTotalServiceEngines]: 'Total Service Engines',
    [requestPerSecColumnTitle]: 'Requests per second',
    [connectionsPerSecColumnTitle]: 'Connections per second',
    [virtualHostingReferenceColumnTitle]: 'Virtual Hosting Reference',
    [primaryLabel]: ' (primary)',
    [parentLabel]: 'Parent',
    [childLabel]: 'Child',
    [enhancedVHLabel]: 'Enhanced Virtual Hosting',
    [sniVHLabel]: 'SNI',
    [columnValueSuffix]: '(+{0} More)',
    [editToViewAllMessage]: 'Edit the Virtual Service to view all entries.',
};
